import React, { useState } from 'react';
import { Screen } from '../App';
import { User } from '../storage';
interface Props { navigate: (s: Screen) => void; user: User | null; }
const slides = [
  {emoji:'🌱',title:'You are safe here',body:"This is a place to talk about your hardest students — without judgment, without anyone watching, without the pressure of doing it perfectly."},
  {emoji:'🔒',title:'Privacy built in',body:"We use initials and grade only — never full names. Student privacy is always protected. You'll see this reminder every time you add a student."},
  {emoji:'🧠',title:'Gets smarter over time',body:"The more you use Decode My Student, the smarter it gets about each of your students. It notices patterns you might miss."},
  {emoji:'💚',title:'You matter too',body:"We will always ask how YOU are doing. You cannot pour from an empty cup. Your wellbeing is part of this program."},
];
export default function Onboarding({ navigate, user }: Props) {
  const [slide, setSlide] = useState(0);
  return (
    <div style={{minHeight:'100vh',display:'flex',flexDirection:'column',padding:'40px 24px'}}>
      <div style={{textAlign:'center',marginBottom:16}}><h2 style={{fontSize:22,color:'var(--teal)'}}>Welcome, {user?.firstName}!</h2></div>
      <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'center'}}>
        <div className="card animate-in" style={{textAlign:'center',padding:'40px 24px'}}>
          <div style={{fontSize:56,marginBottom:20}}>{slides[slide].emoji}</div>
          <h2 style={{fontSize:24,marginBottom:16}}>{slides[slide].title}</h2>
          <p style={{color:'var(--text-secondary)',fontSize:16,lineHeight:1.7}}>{slides[slide].body}</p>
        </div>
        <div style={{display:'flex',justifyContent:'center',gap:8,margin:'24px 0'}}>
          {slides.map((_,i)=><div key={i} style={{width:8,height:8,borderRadius:'50%',background:i===slide?'var(--teal)':'#d0cac2',transition:'0.2s'}}/>)}
        </div>
      </div>
      <div>
        {slide<slides.length-1?<button onClick={()=>setSlide(slide+1)} className="btn-primary">Next</button>:<button onClick={()=>navigate('dashboard')} className="btn-primary">Let's Get Started</button>}
        {slide>0&&<button onClick={()=>setSlide(slide-1)} className="btn-secondary" style={{marginTop:10}}>Back</button>}
      </div>
    </div>
  );
}
